import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { FeaturedJobs } from './components/FeaturedJobs';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { Testimonials } from './components/Testimonials';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <FeaturedJobs data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <Benefits data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}